import { Processo } from './Processo';
import { TipoMovimentacaoCnj } from './TipoMovimentacaoCnj';

export class MovimentacaoProcesso {
    id = 0;
    processo = new Processo();
    tipoMovimentacaoCnj = new TipoMovimentacaoCnj();
    dataHora =  new Date();
    movimento = '';
    ativo = 0;
}